import { FormGroup } from '@angular/forms';
import { toZonedTime, format, toDate } from 'date-fns-tz';
import { TipoDocumento } from '../enum/global.enum';

/**
 * ReactiveForm
 * Se espera que en el mensaje que esta retornando tenga el nombre del input "fieldName"
 * @param form
 * @param fieldName
 * @param errorMessage
 * @returns
 */
export function setErrorForFormField(form: FormGroup | null, fieldName: string, errorMessage: string) {
  if (!form) return;
  const regex = new RegExp(`\\b${fieldName}\\b`, 'i');
  const formControl = form.get(fieldName);

  if (formControl && regex.test(errorMessage)) {
    formControl.setErrors({ customError: errorMessage });
  }
}

export function construirUrl(url: string, paginacion?: any, where?: object, orderBy?: any): string {
  const params = new URLSearchParams();
  if (paginacion) {
    params.append('limit', paginacion.limit);
    params.append('page', paginacion.page);
  }

  if (where) {
    params.append('where', JSON.stringify(where));
  }

  if (orderBy) {
    params.append('orderBy', JSON.stringify(orderBy));
  }

  return `${url}?${params.toString()}`;
}

export function tipoTransaccion(tipo: string): any {
  const tipoTransaccion: { [key: string]: any } = {
    '1': { tipo: 'Paso', transaccion: 'Pago con saldo', icono: 'assets/icons/tolis/TOLIS_Icon Display_Saldo.svg' },
    '2': {
      tipo: 'Recarga',
      transaccion: 'Recarga',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_RecargarCuenta.svg',
    },
    '3': {
      tipo: 'Ajuste de paso',
      transaccion: 'Débito',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_FlechaIzquierda.svg',
    },
    '4': {
      tipo: 'Ajuste de paso',
      transaccion: 'Crédito',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_FlechaDerecha.svg',
    },
    '5': {
      tipo: 'Paso',
      transaccion: 'Pago inmediato',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_IngresarTarjeta.svg',
    },
    '6': {
      tipo: 'Pago',
      transaccion: 'Pago con tarjeta',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_IngresarTarjeta.svg',
    },
    '7': {
      tipo: 'Pago mixto',
      transaccion: 'Pago con saldo y tarjeta',
      icono: 'assets/icons/tolis/TOLIS_Icon_Display_pago_mixto.svg',
    },
    '8': {
      tipo: 'Registro de medio de pago',
      transaccion: 'Tarjeta crédito/débito',
      icono: 'assets/icons/tolis/TOLIS_Icon_Display_Tarjeta.svg',
    },
    '9': {
      tipo: 'Cambio',
      transaccion: 'Forma de pago',
      icono: 'assets/icons/tolis/TOLIS_Icon_Display_Movimientos.svg',
    },
    '10': {
      tipo: 'Compra',
      transaccion: 'Compra en la plataforma',
      icono: 'assets/icons/tolis/TOLIS_Icon Display_Facturas.svg',
    },
  };

  return tipoTransaccion[tipo] || 'Tipo de transacción desconocida.';
}

export function convertTimeZoneDateToOther(date: Date, timeZone: string): Date {
  const zonedDate = toZonedTime(date, timeZone);
  const pattern = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
  const output = format(zonedDate, pattern, { timeZone });
  return toDate(output);
}

export function validatePlaceToPayReturnUrl(currentUrl: string): string {
  const segments = currentUrl.split('/');
  const lastSegment = segments.pop();

  const hasLastSegment = /^[\d\-]+$/.test(lastSegment ?? '');

  const validateUrl = hasLastSegment ? currentUrl.split('/').slice(0, -1).join('/') : currentUrl;

  return validateUrl;
}

/**
 * Retorna la configuración de validación para el campo identificación según el tipo de documento
 * @param tipoDocumentoId id del tipo de documento
 */
export function getValidacionIdentificacion(tipoDocumentoId: number) {
  let pattern: RegExp;
  let maxLength: number;
  let pTooltipMessage: string;

  switch (tipoDocumentoId) {
    case TipoDocumento.CEDULA_CIUDADANIA:
      pattern = /^[1-9][0-9]{3,9}$/;
      maxLength = 10;
      pTooltipMessage = "Máximo 10 caracteres";
      break;
    case TipoDocumento.NIT:
      pattern = /^[1-9]\d{6,8}$/;
      maxLength = 9;
      pTooltipMessage = "Máximo 9 caracteres. El NIT debe ser ingresado sin el dígito verificador";
      break;
    default:
      pattern = /^([a-zA-Z]{1,5})?[1-9][0-9]{3,9}$/;
      maxLength = 10;
      pTooltipMessage = "Máximo 10 caracteres";
      break;
  }

  return { pattern, maxLength, pTooltipMessage };
}
